import { createBlockGameModel } from 'features/block-game';
import { createUnblockGameModel } from 'features/unblock-game';
import { createGameRegistryModel } from 'entities/game';
import { accountPageModel } from './account-page-model';

const blockGameModel = createBlockGameModel();

const unblockGameModel = createUnblockGameModel();

const gameRegistryModel = createGameRegistryModel({
	$accountId: accountPageModel.$accountId,
	onUpdate: [
		accountPageModel.accountIdSet,
		blockGameModel.mutation.finished.success,
		unblockGameModel.mutation.finished.success,
	],
});

export const accountPageGamesModel = {
	gameRegistryModel,
	blockGameModel,
	unblockGameModel,
};
